import { useEffect, useState } from 'react';
import config from '../../utils/apiUrl';
import formatDate from '../../utils/formatDate';
import formatMoney from '../../utils/formatMoney';

const useFetchTransactions = ({ company }, type) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const columns = [
    {
      name: 'Fecha',
      selector: (row) => row.datePayed,
      sortable: true,
    },
    {
      name: 'Fundación',
      selector: (row) => row.foundation,
      sortable: true,
    },
    {
      name: 'Campaña',
      selector: (row) => row.campaign,
      sortable: true,
    },
    {
      name: 'Usuario',
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: 'Correo',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Medio de pago',
      selector: (row) => row.paymentMethod,
      sortable: true,
    },
    {
      name: 'Total',
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: 'Estado',
      selector: (row) => row.status,
      sortable: true,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${
            config.apiUrl
          }/company/admin/getTransactions?company=${company}&type=${encodeURIComponent(
            type
          )}`
        );

        if (!response.ok) {
          throw new Error(`Error en la solicitud: ${response.statusText}`);
        }

        const result = await response.json();

        // Validar que la respuesta tenga el formato esperado
        const formattedData = (
          Array.isArray(result) ? result : result.payments || []
        ).map((item) => ({
          ...item,
          datePayed: formatDate(item.datePayed),
          amount: formatMoney(item.amount),
        }));

        setData(formattedData);
      } catch (err) {
        const errorMessage =
          err.message ||
          'Ocurrió un error inesperado al cargar las transacciones';
        setError(errorMessage);
        console.error('Error:', errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [company]);

  return { columns, data, loading, error };
};

export default useFetchTransactions;
